import { render, staticRenderFns } from "./addressCardSkeleton.vue?vue&type=template&id=44e9d287&scoped=true"
import script from "./addressCardSkeleton.vue?vue&type=script&lang=js"
export * from "./addressCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./addressCardSkeleton.vue?vue&type=style&index=0&id=44e9d287&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e9d287",
  null
  
)

export default component.exports